import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/PolicyPages.css";

const RefundPolicy = () => {
  return (
    <>
      <Header />

      <div className="policy-hero">
        <h1>Refund & Cancellation Policy</h1>
        <p>
          Please review our refund and cancellation guidelines before requesting
          travel assistance for Ranthambore tour packages.
        </p>
      </div>

      <div className="policy-wrapper">

        {/* PAYMENT & CONFIRMATION */}
        <div className="policy-section">
          <h2>Travel Assistance & Initial Payment</h2>

          <p>
            Ranthambore Tours & Travel Assistance provides services to help
            travelers plan their Ranthambore trip, including safari experiences,
            accommodation, and travel support. To initiate the planning process,
            a small advance amount may be required.
          </p>

          <p>
            This amount allows us to begin coordinating travel arrangements,
            checking availability with authorised operators, and preparing
            suitable tour options.
          </p>
        </div>

        {/* REFUND IF NOT POSSIBLE */}
        <div className="policy-section">
          <h2>Full Refund if Arrangement Is Not Possible</h2>

          <p>
            If we are unable to arrange the requested travel components,
            including safari experience, due to unavailability or any other
            reason, the full advance amount paid by the customer will be refunded.
          </p>

          <p>
            We aim to maintain transparency and ensure that customers do not lose
            money if the requested arrangements cannot be fulfilled.
          </p>
        </div>

        {/* NON REFUNDABLE */}
        <div className="policy-section">
          <h2>Non-Refundable After Confirmation</h2>

          <p>
            Once travel components such as safari experience or related services
            are confirmed through authorised operators, the amount becomes
            non-refundable.
          </p>

          <p>
            This is because such services are governed by operator and forest
            department regulations and are generally non-cancellable and
            non-refundable.
          </p>
        </div>

        {/* CUSTOMER RESPONSIBILITY */}
        <div className="policy-section">
          <h2>Customer Responsibility</h2>

          <p>
            Customers must provide accurate traveler information required for
            travel arrangements. Incorrect or incomplete details may lead to
            rejection or cancellation by the respective authorities or operators.
          </p>

          <p>
            In such cases, refund eligibility will depend on the policies of the
            authorised operators and service providers.
          </p>
        </div>

        {/* DISCLAIMER */}
        <div className="policy-section">
          <h2>Important Disclaimer</h2>

          <p>
            Ranthambore Tours & Travel Assistance is an independent travel
            service provider offering trip planning and safari experience
            coordination.
          </p>

          <p>
            We are not affiliated with the Forest Department or any government
            authority and are not an official safari booking portal.
          </p>

          <p>
            All safari experiences are conducted by authorised operators as per
            park regulations.
          </p>
        </div>

        {/* CONTACT */}
        <div className="policy-section">
          <h2>Contact Information</h2>

          <p>
            <strong>Business Name:</strong> Ranthambore Tours & Travel Assistance <br />
            <strong>Location:</strong> Gurgaon, Haryana, India <br />
            <strong>Phone:</strong> +91-9217691062 <br />
            <strong>Email:</strong> support@safariranthamborebooking.com
          </p>
        </div>

      </div>

      
    </>
  );
};

export default RefundPolicy;